export default [
  {
    type: 'selection',
    width: 55,
    show: true,
  },
  {
    title: '编号',
    key: 'id',
    minWidth: 50,
    maxWidth: 100,
    show: true,
  },
  {
    title: '标题',
    key: 'title',
    show: true,
  },
  {
    title: '符号',
    key: 'symbol',
    show: true,
  },
  {
    title: '是否富文本',
    key: 'rich',
    slot: 'rich',
    show: true,
  },
  {
    title: '操作',
    key: 'action',
    slot: 'action',
    width: 120,
    align: 'center',
    fixed: 'right',
    show: true,
  },
]
